// Add this method for loading
export const showLoading = async function () {

    $('#loadingContainer').show();

    $('html').css('overflow', 'hidden');

    startProgressBar('#progressBar1');

    setTimeout(() => {
        $('#loadingMessage').text('Locating Home...');
        startProgressBar('#progressBar1');
    }
        , 2500);
    setTimeout(() => {
        $('#loadingMessage').text('Reviewing County Data...');
        startProgressBar('#progressBar1');
    }
        , 5000);
    setTimeout(() => {
        $('#loadingMessage').text('Validating Property Information...');
        startProgressBar('#progressBar1');
    }
        , 7500);
    setTimeout(() => {
        $('#loadingMessage').text('Calculating Coverages ...');
        startProgressBar('#progressBar1');
    }
        , 12500);
    setTimeout(() => {
        $('#loadingMessage').text('Your Quote is Almost Ready...');
        startProgressBar('#progressBar1');
    }
        , 15000);
};

async function startProgressBar(e) {

    $(e).addClass('notransition');
    $(e).attr('style', 'width: 0%');
    await sleep(100);
    $(e).removeClass('notransition');
    await sleep(100);

    for (var i = 0; i <= 200; i++) {
        updateProgress(i, e);
        await sleep(10);
    }

}

function updateProgress(percentage, e) {
    if (percentage > 100) percentage = 100;
    $(e).css('width', percentage + '%');
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}